export const INFLUENCERS_RESET_STATE = 'INFLUENCERS_RESET_STATE';
export const INFLUENCERS_CURRENT_ITEM = 'INFLUENCERS_CURRENT_ITEM';

export const INFLUENCERS_REQUEST_LOADING = 'INFLUENCERS_REQUEST_LOADING';
export const INFLUENCERS_REQUEST_SUCCESS = 'INFLUENCERS_REQUEST_SUCCESS';
export const INFLUENCERS_REQUEST_FAILED = 'INFLUENCERS_REQUEST_FAILED';

export const INFLUENCERS_CURRENT_ACTION = 'INFLUENCERS_CURRENT_ACTION';
export const INFLUENCERS_RESET_ACTION = 'INFLUENCERS_RESET_ACTION';